import React from "react";
import { useSelector } from "react-redux";
import FichaCliente from "../../turnos/agenda/FichaCliente";
import { ClientesApiContext, clientesAdapter } from "../../clientes/clientesApi";

/* "Ver ficha" desde el detalle de una reserva de cancha o mesa: abre la ficha del negocio (o permite crearla o
   vincularla) con /api/organizer/clients. Solo el dueño puede desvincular; lo demás lo decide el servidor. */
const VerFichaReserva = ({ reservationId, onVolver, onClose }) => {
  const esEmpleado = useSelector((s) => s.auth)?.user?.tipo === "empleado";
  return (
    <ClientesApiContext.Provider value={clientesAdapter}>
      <FichaCliente
        key={reservationId}
        tipo="reserva"
        reservationId={reservationId}
        puedeDesvincular={!esEmpleado}
        onVolver={onVolver}
        onClose={onClose}
      />
    </ClientesApiContext.Provider>
  );
};

export default VerFichaReserva;
